<div class="general-confirmation">
  <div class="coworker-confirmation-container">
    <div class="header">
      <div class="thanks">
        {{ "general.thanks" | translate }}
      </div>
      <div class="title" *ngIf="!bookingConfirmationMode">
        {{ "coworker.bookings.cancel-confirm-title" | translate }}
      </div>
      <div class="title" *ngIf="bookingConfirmationMode">
        {{ "coworker.booking.confirm-reservation-title" | translate }}
      </div>
    </div>
    <div class="description" *ngIf="!bookingConfirmationMode">
      {{ "coworker.bookings.cancel-confirm-description" | translate }}
    </div>
    <div class="description" *ngIf="bookingConfirmationMode">
      {{ "coworker.booking.confirm-reservation-description" | translate }}
    </div>

    <div class="img">
      <img [src]="getConfirmation" alt="" />
    </div>
    <div *ngIf="bookingConfirmationMode">
      <div class="booking-confirm">
        <ul class="lastBooking">
          <li><p>Nombre Workspace: <strong>{{lastBooking?.coworking.company_name}}</strong> </p></li>
          <li><p>Fecha de inicio: <strong>{{lastBooking?.start_date}}</strong></p></li>
          <li><p>Fecha de fin: <strong>{{lastBooking?.end_date}}</strong></p></li>
          <li><p>Hora de inicio: <strong>{{lastBooking?.start_time}}</strong></p></li>
          <li><p>Hora de fin: <strong>{{lastBooking?.end_time}}</strong></p></li>
          <li><p>CrÃ©ditos Cowing: <strong>{{lastBooking?.public_price}} C</strong></p></li>
          <li><p>DirecciÃ³n Workspace: <strong>{{lastBooking?.coworking.fiscal_address}}</strong></p></li>
        </ul>
      </div>
    </div>
  </div>
</div>

<div class="action">
  <cowing-button *ngIf="bookingConfirmationMode" [label]="'general.back-booking' | translate"
    [type]="EButtonType.Primary" [iconShow]="true" [iconName]="'arrowRight'" (event)="redirectToBookings()">
  </cowing-button>
  <cowing-button *ngIf="!bookingConfirmationMode" [label]="'general.confirm' | translate" [type]="EButtonType.Primary"
    [iconShow]="true" [iconName]="'arrowRight'" (event)="redirectToBookings()">
  </cowing-button>
</div>